<script>
    export let short = false;
    export let ajankohtaistaUrl = "2025-05-01_kesa_aikataulut";
    let title = "Pihasavotan aika! | Ja muita ryhmätreenimuutoksia";
    let titlePic = "/svelte-site/img/treenivinkit/leka.jpg";
    let firstPara = "Kesän pihatreenit alkavat, ja muitakin pieniä muutoksia yhteistreeneihin kesän myötä on tulossa. Lue tästä tarkemmin kevään ja kesän ohjelmasta.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h1>{title}</h1>
                    <b>Viimeinen tiistain syke 6.5.</b><br>
                    <p>Alkuvuodesta vastasimme kysyntään ja lisäsimme tiistaille Kasken. Tiistaina 6.5. pidettävä Savotan jälkeinen Kaski on toistaiseksi viimeinen tälle keväälle.  </p>
                    <b>Kehonhuolto ja Pilates jää tauolle 11.5.</b><br>
                    <p>11.5. on kevään viimeinen ohjattu Kehonhuolto. Hyödynnä vielä viimeiset mahdollisuudet parantaa liikkuvuutta ja kokonaisvaltaista hyvinvointia!</p>
                    <p>Iso kiitos jälleen Kirsille kevään ohjauksista! 🥰</p>
                    <b>Helatorstaina 29.5 normaali treeniaikataulu</b><br>
                    <p>Myös toukokuun lopussa 29.5. helatorstaina pidetään molemmat Kasket normaalisti.</p>
                    <b>Pihatreenejä toukokuusta alkaen</b>
                    <p>Toukokuussa käynnistyvät jälleen Pihasavotat! Pääsemme jälleen nauttimaan kesäkeleistä myös treeneissä. Olemme myös valmiita järjestämään muita yhteistreenejä pihalla ilmojen osuessa kohdilleen. Näiden yksityiskohdista voidaan jutella salilla tarkemmin.</p>
                    <p>Lauantain Savotat klo 11 pyritään siis pitämään pihalla, jos ilman sallivat. Pihatreenit eivät vaadi sen kummempia varusteita. Tosin jos ei halua sisäkenkiä kuluttaa asfaltilla, kannattaa ottaa juoksuun sopivat ulkokengät matkaan. Hanskat saattavat olla myös kivat, kun esimerkiksi punnerretaan. Muita tärppejä kesäkuumalla voisi olla pyyhe, lippis, aurinkolasit ja uv-suojakerroin sen mukaan miten itse koet tarpeelliseksi. Juomista kuluu ulkona paljon, koska yleensä salin edustalla on todella lämmin.</p>
                    <b>Kesän kevennys päivystyksen ja ryhmätuntien osalta 1.6. alkaen</b><br>
                    <p>Kesän myötä siirrymme kevennettyyn aikatauluun 1.6. alkaen. Kesäkuussa on yksi treeni maanantaina, tiistaina ja torstaina klo 18, sekä lauantaina klo 11.</p>
                    <p>Juhannuksen jälkeen maanantain treenit jäävät pois heinäkuun loppuun asti.</p>
                    <b>Aikataulu ajalla 1.6.-31.7</b>
                    <ul>
                        <li>Maanantai: Kaski klo 18 (16.6. asti)</li>
                        <li>Tiistai: Savotta klo 18 </li>
                        <li>Torstai: Kaski klo 18</li>
                        <li>Lauantai: Pihasavotta klo 11</li>
                    </ul>
                    <p>Kesäaikataulut päivittyvät kalenteriin lähempänä, ja voit aina tarkistaa voimassaolevat treeniajat <a href="https://www.dynamosali.com/treenit-aukioloajat">täältä. </a></p>
                    <p>Aurinkoista kevättä ja kesän odotusta!</p>
                    <p>Toivottelevat</p>
                    <p>Dynamosalin koutsit</p>

                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="/svelte-site/img/ajankohtaista/koysi.jpg"/>
                </div>
            </div>
        </article>
    </div>
{/if}
